import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class StorageService {
    readonly accessTokenKey = 'accessToken';
    readonly imageTokens = 'imageToken';
    readonly currentUserKey = 'currentUser';
    readonly refreshTokenKey = 'refreshToken';
    readonly currentUserIdKey = 'currentUserId';
    readonly currentUserName = 'currentUser';
    readonly currentUserFirstName = 'currentUser';
    readonly currentUserLastName = 'currentUser';
    readonly rememberMeKey = 'rememberMe';
    readonly userImage = 'userImage';
    readonly messagesCounter = 'messagesCounter';
    readonly travelCounterStr = 'travelCounterStr';
    readonly travelHideCounterP = 'travelHideCounterP';
    readonly lastActivityKey = 'lastActivity';
    // readonly rememberMe = true;
    private _localItemSubject = new BehaviorSubject<any>(null);

    constructor() {
    }

    getStorageItem(key: string) {
        return this.rememberMe ? this.getLocalItem(key) : this.getSessionItem(key);
    }

    setStorageItem(key: string, value: any) {
        return this.rememberMe ? this._setItemLocal(key, value) : this._setItemSession(key, value);
    }

    removeStorageItem(key: string) {
        return this.rememberMe ? this.removeLocalItem(key) : this.removeSessionItem(key);
    }

    get lastActivity(): number {
        return Number(this.getStorageItem(this.lastActivityKey));
    }

    set lastActivity(value: number) {
        this.setStorageItem(this.lastActivityKey, value ? String(value) : value);
    }

    get refreshToken(): string {
        return this.getStorageItem(this.refreshTokenKey);
    }

    set travelCounter(value: any) {
        this.setLocalItem(this.travelCounterStr, JSON.stringify(value));
    }

    get travelCounter(): any {
        return JSON.parse(this.getLocalItem(this.travelCounterStr));
    }

    set travelHideCounter(value: any) {
        this.setStorageItem(this.travelHideCounterP, JSON.stringify(value));
    }

    get travelHideCounter(): any {
        return JSON.parse(this.getStorageItem(this.travelHideCounterP));
    }
    get chatCounter(): any {
        return JSON.parse(this.getStorageItem(this.messagesCounter));
    }

    set chatCounter(value: any) {
        this.setStorageItem(this.messagesCounter, JSON.stringify(value));
    }
    set refreshToken(value: string) {
        this.setStorageItem(this.refreshTokenKey, value);
    }

    private _setItemLocal(key: string, value: any) {
        return (value === null) ? this.removeLocalItem(key) : this.setLocalItem(key, value);
    }

    private _setItemSession(key: string, value: any) {
        return (value === null) ? this.removeSessionItem(key) : this.setSessionItem(key, value);
    }

    get rememberMe(): boolean {
        return this.getLocalItem(this.rememberMeKey) === 'true';
    }

    set rememberMe(value: boolean) {
        value ? this.setLocalItem(this.rememberMeKey, String(value)) : this.removeLocalItem(this.rememberMeKey);
    }

    get accessToken(): string {
        return this.getStorageItem(this.accessTokenKey);
    }

    set accessToken(value: string) {
        this.setStorageItem(this.accessTokenKey, value);
    }

    set imageToken(value: string) {
        this.setStorageItem(this.imageTokens, value);
    }

    get imageToken(): string {
        return this.getStorageItem(this.imageTokens);
    }

    get name(): string {
        return this.getStorageItem(this.currentUserName);
    }

    set name(value: string) {
        this.setStorageItem(this.currentUserName, value);
    }

    get firstName(): string {
        return this.getStorageItem(this.currentUserFirstName);
    }

    set firstName(value: string) {
        this.setStorageItem(this.currentUserFirstName, value);
    }

    get lastName(): string {
        return this.getStorageItem(this.currentUserLastName);
    }

    set lastName(value: string) {
        this.setStorageItem(this.currentUserLastName, value);
    }

    get user(): any {
        return JSON.parse(this.getStorageItem(this.currentUserKey));
    }

    set user(value: any) {
        this.setStorageItem(this.currentUserKey, JSON.stringify(value));
    }

    get image(): any {
        return JSON.parse(this.getStorageItem(this.userImage));
    }

    set image(value: any) {
        this.setStorageItem(this.userImage, JSON.stringify(value));
    }

    get userId(): number {
        return Number(this.getStorageItem(this.currentUserIdKey));
    }

    set userId(value: number) {
        const strValue = value === null ? null : String(value);
        this.setStorageItem(this.currentUserIdKey, strValue);
    }

    private getLocalItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    private removeLocalItem(key: string): void {
        localStorage.removeItem(key);
    }

    private setLocalItem(key: string, data: string): void {
        localStorage.setItem(key, data);
        const resp = {};
        resp[key] = data;
        this._localItemSubject.next(resp);
    }

    private getSessionItem(key: string): string | null {
        return sessionStorage.getItem(key);
    }

    private removeSessionItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    private setSessionItem(key: string, data: string): void {
        sessionStorage.setItem(key, data);
        const resp = {};
        resp[key] = data;
        this._localItemSubject.next(resp);
    }

    localItemChanged(): Observable<any> {
        return this._localItemSubject.asObservable();
    }

    clear() {
        for (const key in localStorage) {
            if (localStorage.hasOwnProperty(key)) {
                delete localStorage[key];
            }
        }
    }
}
